import {oldSystemMigration} from './old-system.migration';
import {version2000To3000Migration} from './version2000To3000Migration.migration';

export const workspaceMigrations: { [key: number]: (...args) => any } = {
    1: oldSystemMigration,
    2: version2000To3000Migration
};

Object.freeze(workspaceMigrations);
